import { render, staticRenderFns } from "./menuTop.vue?vue&type=template&id=3f88474c&scoped=true&"
import script from "./menuTop.vue?vue&type=script&lang=tsx&"
export * from "./menuTop.vue?vue&type=script&lang=tsx&"
import style0 from "./menuTop.vue?vue&type=style&index=0&id=3f88474c&lang=scss&scoped=true&"
import style1 from "./menuTop.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f88474c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f88474c')) {
      api.createRecord('3f88474c', component.options)
    } else {
      api.reload('3f88474c', component.options)
    }
    module.hot.accept("./menuTop.vue?vue&type=template&id=3f88474c&scoped=true&", function () {
      api.rerender('3f88474c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menuTop.vue"
export default component.exports